var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 37,
    viewBox: "0 0 327 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_69_2917",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 327,
    height: 37
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M327 0H0V37H327V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_69_2917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.477 11.6961C169.477 11.6961 169.515 11.6961 169.537 11.6961L173.944 11.6796C180.201 11.6796 183.723 8.30097 187.12 3.82361L190.023 0L181.916 0.0274684C181.557 0.0274684 179.164 0.0769117 178.052 0.0769117C171.23 0.0769117 166.862 5.69696 163.915 11.8938L151.542 0H136.141L159.867 22.8153V22.8263H159.888L159.91 22.8592C158.83 24.6831 157.734 25.2929 156.687 25.3039C156.665 25.3039 156.649 25.3039 156.627 25.3039L152.22 25.3204C145.963 25.3204 142.441 28.699 139.044 33.1764L136.141 37L144.248 36.9725C144.607 36.9725 147 36.9231 148.112 36.9231C154.934 36.9231 159.302 31.3085 162.249 25.1007L174.622 37H190.023L166.297 14.1847V14.1737H166.276L166.254 14.1408C167.334 12.3169 168.43 11.7016 169.477 11.6906",
    fill: "#40D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1333 0H14.6957L25.2453 18.4973H19.8294C14.0879 18.4973 8.78592 21.5957 5.91516 26.6279L0 37H5.42133C11.1574 37 16.4648 33.9016 19.3355 28.8693L20.6651 26.5345C22.0977 24.0184 23.8777 21.7275 25.9453 19.7223L31.1604 28.8693C34.0312 33.9016 39.3331 37 45.0746 37H50.5828L34.0312 8.10869C31.1604 3.08745 25.8639 0 20.1333 0Z",
    fill: "#40D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.454 8.10869C307.578 3.09295 302.287 0 296.556 0H291.118L301.668 18.4973H296.252C290.51 18.4973 285.209 21.5957 282.338 26.6279L276.423 36.9945H281.844C287.58 36.9945 292.882 33.8961 295.753 28.8638L297.088 26.529C298.52 24.0129 300.3 21.722 302.362 19.7169L307.583 28.8638C310.448 33.8961 315.756 36.9945 321.492 36.9945H327.005L310.454 8.10319V8.10869Z",
    fill: "#40D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0674 30.1109H60.9806C63.2273 27.7926 64.5025 24.6667 64.5025 21.3924V0H53.0195V37H90.6107V27.1663H69.0068C66.098 27.1663 63.287 28.2101 61.0674 30.1109Z",
    fill: "#40D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.53 30.1109H244.443C246.689 27.7926 247.965 24.6667 247.965 21.3924V0H236.476V37H274.073V27.1663H252.464C249.56 27.1663 246.749 28.2101 244.53 30.1109Z",
    fill: "#40D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.086 0H94.5779V37H133.216V27.1663H112.882C108.329 27.1663 105.176 28.2266 103.755 30.2373C103.613 30.457 103.673 30.3581 103.744 30.2373H103.755C104.086 29.6769 104.395 29.1605 104.704 28.6826C105.057 28.1277 106.007 26.551 106.343 26.095C108.036 23.8261 109.697 22.7988 112.812 22.7988H116.497C120.86 22.7988 124.886 20.442 127.068 16.6184L128.517 14.0748H118.293C113.935 14.0748 109.903 16.4316 107.721 20.2552L106.549 22.3099L105.876 23.4855L104.373 26.117L104.807 24.8974C105.643 22.5736 106.066 20.1234 106.066 17.6512V9.03163H133.216V0H100.086Z",
    fill: "#40D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.348 0H192.845V37H231.478V27.1663H211.144C206.597 27.1663 203.438 28.2266 202.016 30.2373C201.875 30.457 201.935 30.3581 202.006 30.2373H202.016C202.347 29.6769 202.662 29.1605 202.966 28.6826C203.319 28.1277 204.269 26.551 204.61 26.095C206.298 23.8261 207.964 22.7988 211.074 22.7988H214.764C219.122 22.7988 223.154 20.442 225.335 16.6184L226.784 14.0748H216.56C212.197 14.0748 208.165 16.4316 205.989 20.2552L204.817 22.3099L204.144 23.4855L202.635 26.117L203.069 24.8974C203.905 22.5736 204.328 20.1234 204.328 17.6512V9.03163H231.478V0H198.348Z",
    fill: "#40D5FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.914183979c3da8496e9f822907e91c54.svg";
export { ForwardRef as ReactComponent };